
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/property-details",
      function () {
        return require("private-next-pages/property-details.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/property-details"])
      });
    }
  